export function settingIsEnabled(settings, camelKey, snakeKey = null, defaultValue = true) {
  if (!settings) {
    return defaultValue;
  }

  if (Object.prototype.hasOwnProperty.call(settings, camelKey)) {
    return settings[camelKey] !== false;
  }

  if (snakeKey && Object.prototype.hasOwnProperty.call(settings, snakeKey)) {
    return settings[snakeKey] !== false;
  }

  return defaultValue;
}

export function calendarIsEnabled(user) {
  return settingIsEnabled(user?.settings, 'calendarEnabled', 'calendar_enabled', true);
}
